import { useState } from "react";
import { Copy, Gift, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { PageHeader, Panel } from "@/components/layout/AppShell";
import { Input } from "@/components/ui/input";
import { useRx } from "@/context/AuthContext";
import PricingView from "@/components/PricingView";

export function PricingPage() {
  return <div data-testid="pricing-page"><PricingView /></div>;
}

export function ReferralPage() {
  const { api, me, setMe } = useRx();
  const [code, setCode] = useState(() => localStorage.getItem("robox_ref") || "");
  const link = `${window.location.origin}/?ref=${me?.referral_code || ""}`;
  const msg = `I use Robo-X for live Strength Scores & trade signals. Join with my code ${me?.referral_code} and get 7 days of Pro free: ${link}`;
  const apply = async () => {
    try { setMe(await api("post", "/referral/apply", { code })); toast.success("Referral applied: 7 days Pro unlocked"); setCode(""); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not apply code"); }
  };
  return (
    <div data-testid="referral-page">
      <PageHeader eyebrow="Refer & Earn" title="Invite traders" sub="Friends who join with your code get 7 days of Pro free. Track how many traders you've brought in." />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Panel title="Your referral code">
          <div className="flex items-center gap-4">
            <div className="h-14 w-14 rounded-xl bg-[#00FF66]/10 border border-[#00FF66]/30 grid place-items-center"><Gift className="text-[#00FF66]" /></div>
            <div>
              <div className="font-data text-3xl font-bold tracking-widest" data-testid="my-referral-code">{me?.referral_code || "…"}</div>
              <div className="text-xs text-gray-500 mt-1"><span className="font-data text-white" data-testid="referral-count">{me?.referral_count ?? 0}</span> traders joined</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3 mt-6">
            <a href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" data-testid="referral-whatsapp-btn"
              className="flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-black font-bold py-2.5 hover:brightness-110 transition-[filter]"><MessageCircle size={16} /> WhatsApp</a>
            <button onClick={() => { navigator.clipboard?.writeText(msg); toast.success("Invite copied"); }} data-testid="referral-copy-btn"
              className="flex items-center justify-center gap-2 rounded-full border border-white/15 py-2.5 hover:bg-white/5 transition-colors"><Copy size={16} /> Copy invite</button>
          </div>
        </Panel>
        <Panel title="Have a friend's code?">
          {me?.referred_by ? (
            <div className="text-sm text-gray-300" data-testid="referral-applied">Applied code <span className="font-data text-[#00FF66]">{me.referred_by}</span>.</div>
          ) : (
            <div className="flex gap-3">
              <Input value={code} onChange={(e) => setCode(e.target.value)} placeholder="RXABC123" data-testid="referral-code-input" className="bg-black/40 border-white/10 font-data uppercase" />
              <button onClick={apply} disabled={!code} data-testid="referral-apply-btn" className="rounded-full bg-[#007AFF] px-6 font-bold hover:bg-[#0056b3] transition-colors disabled:opacity-50">Apply</button>
            </div>
          )}
        </Panel>
      </div>
    </div>
  );
}
